import { z } from 'zod';

const nullishStringSchema = z.string().nullish();

export const accreditationStageSchema = z.enum([
  'pending_review',
  'data_rejected',
  'pending_data',
  'pending_data_review',
  'data_extra_rejected',
  'pending_contract_sign',
  'pending_contract_review',
  'contract_rejected',
  'approved',
  'okved_failed',
  'pending_edo_sign',
]);

export type AccreditationStage = z.output<typeof accreditationStageSchema>;

export const companyTypeSchema = z.enum(['ip', 'ul']);

export type CompanyType = z.infer<typeof companyTypeSchema>;

const companyRequisitesFields = {
  legal_name: nullishStringSchema,
  marketing_name: nullishStringSchema,
  inn: nullishStringSchema,
  kpp: nullishStringSchema,
  ogrn: nullishStringSchema,
  ogrnip: nullishStringSchema,
  legal_address: nullishStringSchema,
  actual_address: nullishStringSchema,
  accreditation_stage: accreditationStageSchema.nullish(),
};

export const companyRequisitesFieldsSchema = companyRequisitesFields;

export const companyRequisitesSchema = z.object(companyRequisitesFields).transform((raw) => ({
  legalName: raw.legal_name ?? null,
  marketingName: raw.marketing_name ?? null,
  inn: raw.inn ?? null,
  kpp: raw.kpp ?? null,
  ogrn: raw.ogrn ?? null,
  ogrnip: raw.ogrnip ?? null,
  legalAddress: raw.legal_address ?? null,
  actualAddress: raw.actual_address ?? null,
  accreditationStage: raw.accreditation_stage ?? null,
}));

export type CompanyRequisites = z.infer<typeof companyRequisitesSchema>;

export const companySchema = z
  .object({
    id: z.number().optional(),
    ...companyRequisitesFieldsSchema,
    is_blocked: z.boolean().optional(),
    // TODO: Уточнить с бэком финальное имя поля причины блокировки компании и заменить blocked_reason.
    blocked_reason: nullishStringSchema,
    type: companyTypeSchema.nullish(),
  })
  .transform((raw) => ({
    id: raw.id,
    ...companyRequisitesSchema.parse(raw),
    isBlocked: raw.is_blocked ?? false,
    blockedReason: raw.blocked_reason ?? null,
    type: raw.type ?? null,
  }));

export type Company = z.infer<typeof companySchema>;
